<template>
  <div class="my-3">
    <CFormInput
      type="file"
      @change="emitContent"
      :disabled="+info.is_help"
      class="mb-3"
    />
    已上傳檔案：
    <img
      v-if="getFileExtension(fileName)"
      style="max-width: 400px"
      :src="fileName"
    />
    <a v-else v-show="fileName" :href="fileName" download>下載</a>
    <MsgBox
      :show="showMsgBox"
      :errorMsg="errorMsg"
      @close="showMsgBox = false"
    />
  </div>
</template>
<script>
import useQuestionnaire from '@/composables/useQuestionnaire'
import { ref, watch, onMounted } from '@vue/runtime-core'
import MsgBox from '@/components/MsgBox.vue'

export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['content'],
  components: {
    MsgBox,
  },
  setup(props, { emit }) {
    const { uploadImage } = useQuestionnaire()
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const fileName = ref(null)
    const emitContent = async (e) => {
      if (e) {
        const formData = new FormData()
        formData.append('image', e?.target.files[0])
        const res = await uploadImage(formData)
        if (!res.error) {
          emit('content', {
            part_item_id: props.info.part_item_id,
            value_info: res.ret.image || '',
          })
          fileName.value = res.ret.image
        } else {
          showMsgBox.value = true
          errorMsg.value = res.msg
        }
      } else {
        emit('content', {
          part_item_id: props.info.part_item_id,
          type: props.info.type,
          is_help: +props.info.is_help ? '1' : '0',
          help_message: props.info?.help_message ||'',
          is_finish: !!fileName.value,
          value_info:
            +props.info.is_help === 0 || !props.info.is_help
              ? fileName.value
              : null,
        })
      }
    }
    function getFileExtension(filename) {
      const file = /[.]/.exec(filename) ? /[^.]+$/.exec(filename)[0] : undefined
      if (file === 'jpg' || file === 'jpeg' || file === 'png') return true
      else return false
    }
    onMounted(() => {
      emitContent()
    })
    watch(
      () => props.info.value_info,
      (newVal) => {
        fileName.value = newVal
        emitContent()
      },
      { immediate: true },
    )
    watch(
      () => props.info.is_help,
      () => {
        emitContent()
      },
      { immediate: true, deep: true },
    )
    return {
      emitContent,
      showMsgBox,
      errorMsg,
      fileName,
      getFileExtension,
    }
  },
}
</script>
